import { CommandType } from '@shared/constants/CommandValues';
import { IEditProfileContainer } from '@shared/models/deviceProfiles/IEditProfileContainer';
import { useEffect, useState } from 'react';

interface IFilterProfileConfigurations {
    profile: IEditProfileContainer;
    filter: string;
    selectedCommandType?: CommandType | null;
}

const useFilterProfileConfigurations = ({
    profile,
    filter,
    selectedCommandType = '' as CommandType,
}: IFilterProfileConfigurations) => {
    const [filteredMacros, setFilteredMacros] = useState<IEditProfileContainer['macros'] | null>(
        profile?.macros ? profile.macros : []
    );
    const [filteredKeybinds, setFilteredKeybinds] = useState<IEditProfileContainer['commandKeyMappings']>(
        profile?.commandKeyMappings ? profile.commandKeyMappings : []
    );
    const [filteredHotkeys, setFilteredHotkeys] = useState<IEditProfileContainer['hotkeys']>(
        profile?.hotkeys ? profile.hotkeys : []
    );

    useEffect(() => {
        if (!profile) return;
        const filterNormalized = filter?.toLowerCase().trim();
        setFilteredMacros(
            profile.macros.filter(
                (m) =>
                    m.commands.some(
                        (c) =>
                            (c.commandType === selectedCommandType || !selectedCommandType) &&
                            (c.command?.toLowerCase().includes(filterNormalized) || !filterNormalized)
                    ) ||
                    m.name?.toLowerCase().includes(filterNormalized) ||
                    !filterNormalized
            )
        );
        setFilteredKeybinds(
            profile.commandKeyMappings.filter((m) =>
                m.commands.some(
                    (c) =>
                        (c.commandType == selectedCommandType || !selectedCommandType) &&
                        (c.command?.toLowerCase().includes(filterNormalized) || !filterNormalized)
                )
            )
        );
        setFilteredHotkeys(
            profile.hotkeys.filter(
                (m) =>
                    m.command?.toLowerCase().includes(filterNormalized) ||
                    m.displayName?.toLowerCase().includes(filterNormalized) ||
                    !filterNormalized
            )
        );
    }, [selectedCommandType, filter, profile?.id, profile?.hotkeys, profile?.macros, profile?.commandKeyMappings]);

    if (!profile) return { filteredMacros: null, filteredKeybinds: [], filteredHotkeys: [] };
    return { filteredMacros, filteredKeybinds, filteredHotkeys };
};

export default useFilterProfileConfigurations;
